import { call, put, takeLatest } from "redux-saga/effects";
import { GET_MeetingList, POST_Meeting, PUT_Meeting, DELETE_Meeting } from "../services/Meeting";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_MeetingListEffect({ projectId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_MeetingList, token, projectId);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_MeetingList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_MeetingEffect({ projectId, formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(POST_Meeting, token, projectId, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_MeetingEffect({ meetingId, formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(PUT_Meeting, token, meetingId, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_MeetingEffect({ meetingId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(DELETE_Meeting, token, meetingId);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_MeetingList", GET_MeetingListEffect);
  yield takeLatest("POST_Meeting", POST_MeetingEffect);
  yield takeLatest("PUT_Meeting", PUT_MeetingEffect);
  yield takeLatest("DELETE_Meeting", DELETE_MeetingEffect);
}
